import type { EventSink } from './events'
import { NO_TICK } from './world'
import type { World } from './world'

/** Step 6 (checkpoints): crossing a later checkpoint's x makes it the respawn point. */
export function updateCheckpoints(world: World, i: number, events: EventSink): void {
  const p = world.players[i]!
  if (p.respawnAtTick !== NO_TICK) return
  const cps = world.track.checkpoints
  for (let c = p.checkpoint + 1; c < cps.length && p.x >= cps[c]!.x; c++) {
    p.checkpoint = c
    events.push({ type: 'checkpoint', tick: world.tick, player: i, checkpoint: c })
  }
}

/** Step 8 (finish): the first tick `x >= finishX` gives the next placement. */
export function updateFinish(world: World, i: number, events: EventSink): void {
  const p = world.players[i]!
  if (p.placement !== 0 || p.respawnAtTick !== NO_TICK || p.x < world.track.finishX) return
  world.finishOrder.push(p.id)
  p.placement = world.finishOrder.length
  p.finishTick = world.tick
  events.push({ type: 'finish', tick: world.tick, player: i, placement: p.placement })
}

/**
 * Step 9: `progress = max(progress, x)`, then rank: finished players by placement, racing
 * players after them by progress (desc), ties by player index.
 */
export function updateRanks(world: World): void {
  const { players } = world
  for (const p of players) p.progress = Math.max(p.progress, p.x)
  const order = players.map((_, i) => i)
  order.sort((a, b) => {
    const pa = players[a]!
    const pb = players[b]!
    if (pa.placement !== 0 || pb.placement !== 0) {
      if (pa.placement === 0) return 1
      if (pb.placement === 0) return -1
      return pa.placement - pb.placement
    }
    if (pa.progress !== pb.progress) return pb.progress - pa.progress
    return a - b
  })
  order.forEach((idx, r) => (players[idx]!.rank = r + 1))
}
